import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ProtectedRoute from "./components/common/ProtectedRoute";
import SubscriptionPage from "./components/common/SubscriptionPage";
import SubscriptionCancelPage from "./components/common/SubscriptionCancelPage";
import Layout from "./components/common/Layout";
import SignupSuccessPage from "./components/common/SignupSuccessPage";
import AdminDashboard from "./components/Dashboard/AdminDashboard";
import CaseManagerDashboard from "./components/Dashboard/CaseManagerDashboard";
import FieldAgentDashboard from "./components/Dashboard/FieldAgentDashboard";
import ServerDashboard from "./components/Dashboard/ServerDashboard";
import ClientDashboard from "./components/Dashboard/ClientDashboard";
import CaseList from "./components/CaseManagement/CaseList";
import CaseListPi from "./components/CaseManagement/CaseListPi";
import SubscriptionManager from "./components/common/SubscriptionManager";
import SubscriptionRedirectHandler from "./components/common/SubscriptionRedirectHandler";
import CaseFormPi from "./components/CaseManagement/CaseFormPi";
import CaseDetail from "./components/CaseManagement/CaseDetail";
import CaseDetailsPi from "./components/CaseManagement/CaseDetailsPi";
import CaseForm from "./components/CaseManagement/CaseForm";
import AgentCasesList from "./components/CaseManagement/AgentCasesList";
import ServerCasesList from "./components/CaseManagement/ServerCasesList";
import MiniCaseDetail from "./components/CaseManagement/MiniCaseDetail";
import UserList from "./components/Users/UserList";
import ClientList from "./components/Clients/ClientList";
import ClientForm from "./components/Clients/ClientForm";
import TeamList from "./components/Teams/TeamList";
import TeamForm from "./components/Teams/TeamForm";
import UserForm from "./components/Users/UserForm";
import UserProfile from "./components/Users/UserProfile";
import TimeEntryForm from "./components/TimeAndExpenses/TimeEntryForm";
import TimeEntryList from "./components/TimeAndExpenses/TimeEntryList";
import AgentTimeEntryForm from "./components/TimeAndExpenses/AgentTimeEntryForm";
import ServerTimeEntryForm from "./components/TimeAndExpenses/ServerTimeEntryForm";
import AgentTimeEntryList from "./components/TimeAndExpenses/AgentTimeEntryList";
import ServerTimeEntryList from "./components/TimeAndExpenses/ServerTimeEntryList";
import MyTasks from "./components/Tasks/MyTasks";
import TaskList from "./components/Tasks/TaskList";
import TaskForm from "./components/Tasks/TaskForm";
import FieldAgentTaskUpdate from "./components/Tasks/FieldAgentTaskUpdate";
import ServerTaskUpdate from "./components/Tasks/ServerTaskUpdate";
import InvoiceList from "./components/Invoicing/InvoiceList";
import PayInvoice from "./components/Invoicing/PayInvoice";
import InvoiceForm from "./components/Invoicing/InvoiceForm";
import InvoiceDetail from "./components/Invoicing/InvoiceDetail";
import LocationsDashboard from "./components/Locations/LocationsDashboard";
import TimeAndExpensesDashboard from "./components/TimeAndExpenses/TimeAndExpensesDashboard";
import  NpsnLogo  from './assets/npsn_logo.png';
import { BiRocket, BiChevronRight } from 'react-icons/bi';

import SignatureCropper from "./components/common/SignatureCropper";


import SuperAdminDashboard from "./components/Dashboard/SuperAdminDashboard";
import OrganizationsArchive from "./components/Organization/OrganizationsArchive";
import SuperAdminForm from "./components/Organization/SuperAdminForm";
import CreateOrganizationForm from "./components/Organization/CreateOrganizationForm";
import OrganizationView from "./components/Organization/OrganizationView";
import EmailTemplates from "./components/common/EmailTemplates";
import SuperAdminProfile from "./components/Users/SuperAdminProfile";
import AuditLogViewer from "./components/superadmin/AuditLogViewer";
import UserDetailsPage from "./components/Users/UserDetailsPage";

import SuperAdminUserList from "./components/superadmin/SuperAdminUserList"; 
import SuperAdminUserView from "./components/superadmin/SuperAdminUserView";
import SuperAdminCaseList from "./components/superadmin/SuperAdminCaseList";
import SuperAdminCaseView from "./components/superadmin/SuperAdminCaseView"; 
import SuperAdminUserEdit from "./components/superadmin/SuperAdminUserEdit";
import SuperAdminTransactions from "./components/superadmin/SuperAdminTransactions";
import Documentation from "./components/common/Documentation";
import OnboardingMonitor from "./components/Onboarding/OnboardingMonitor";
import QuickStartVideoManagement from "./components/superadmin/QuickStartVideoManagement";


import TermsAndConditions from "./components/common/TermsAndConditions";
import PrivacyPolicy from "./components/common/PrivacyPolicy";
import ClientDetails from "./components/Clients/ClientDetails";
import ImportClients from "./components/Clients/ImportClients";

import ConnectStripeScreen from "./components/Users/ConnectStripeScreen";
import VideoPlayer from "./components/common/VideoPlayer";
import StripeConnectSuccess from "./components/Users/StripeConnectSuccess";
import ClientCaseForm from "./components/Clients/ClientCaseForm";
import ClientCaseFormPi from "./components/Clients/ClientCaseFormPi";
import ClientCaseList from "./components/Clients/ClientCaseList";
import ClientCaseListPi from "./components/Clients/ClientCaseListPi";
import ExportClients from "./components/Clients/ExportClients";
import CaldHome2 from "./New"

const Home = () => (
  <div className="min-h-screen bg-slate-50 flex flex-col relative overflow-hidden">
    {/* Background Decorative Elements */}
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-50"></div>
      <div className="absolute top-1/2 -right-24 w-80 h-80 bg-sky-100 rounded-full blur-3xl opacity-50"></div>
    </div>

    {/* Navbar / Top Branding */}
    <header className="relative z-10 px-6 py-8 md:px-12 flex justify-between items-center">
      <div className="flex items-center space-x-2">
        <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-blue-200">
           <BiRocket className="w-6 h-6" />
        </div>
        <span className="text-2xl font-black text-slate-800 tracking-tight">IntelServe</span>
      </div>
      <div className="hidden md:block">
         <Link to="/login" className="text-slate-600 font-semibold hover:text-blue-600 transition-colors">Client Portal</Link>
      </div>
    </header>

    {/* Hero Section */}
    <main className="flex-1 relative z-10 flex flex-col items-center justify-center px-6 text-center max-w-4xl mx-auto">
      <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
        <h1 className="text-4xl md:text-7xl font-black text-slate-900 leading-tight mb-6">
          Professional <span className="text-blue-600">Case Management</span> Redefined.
        </h1>
        <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed">
          The all-in-one platform for process servers, investigators, and legal professionals to manage, track, and scale their operations.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            to="/subscriptions"
            className="w-full sm:w-auto px-10 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-2xl shadow-xl shadow-blue-200 transition-all transform hover:scale-105 flex items-center justify-center text-lg"
          >
            Get Started Free
            <BiChevronRight className="ml-2 w-6 h-6" />
          </Link>
          <Link
            to="/login"
            className="w-full sm:w-auto px-10 py-4 bg-white hover:bg-slate-50 text-slate-800 font-bold rounded-2xl border border-slate-200 shadow-sm transition-all transform hover:scale-105 flex items-center justify-center text-lg"
          >
            Log In to Account
          </Link>
        </div>

        {/* Feature Highlights */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 pt-8 border-t border-slate-200">
          <div className="text-center">
            <p className="text-2xl font-bold text-slate-800">100%</p>
            <p className="text-sm text-slate-500 font-medium">Cloud Secure</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-slate-800">24/7</p>
            <p className="text-sm text-slate-500 font-medium">Real-time Tracking</p>
          </div>
          <div className="text-center hidden md:block">
            <p className="text-2xl font-bold text-slate-800">Unlimited</p>
            <p className="text-sm text-slate-500 font-medium">Scale Potential</p>
          </div>
        </div>
      </div>
    </main>

    {/* Footer / Powered By */}
    <footer className="relative z-10 p-8 flex flex-col items-center">
      <div className="bg-white/50 backdrop-blur-sm border border-slate-200 rounded-3xl p-6 flex flex-col md:flex-row items-center gap-6 shadow-sm">
        <a
          href="https://nationalprocessservernetwork.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-opacity hover:opacity-80"
        >
          <img src={NpsnLogo} alt="NPSN Logo" className="h-10 md:h-12 w-auto" />
        </a>
        <div className="text-center md:text-left">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Infrastructure Partner</p>
          <p className="text-sm font-medium text-slate-600">
            Powered by the{' '}
            <a
              href="https://nationalprocessservernetwork.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-bold hover:underline"
            >
              National Process Server Network LLC
            </a>
          </p>
        </div>
      </div>
      <div className="mt-8 text-slate-400 text-xs font-medium pb-4">
        &copy; {new Date().getFullYear()} IntelServe. All rights reserved.
      </div>
    </footer>
  </div>
);

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<SubscriptionPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/test" element={<CaldHome2 />} />
      {/* <Route path="/signup" element={<Signup />} /> */}
      <Route path="/subscriptions" element={<SubscriptionPage />} />
      <Route path="/signup/cancel" element={<SubscriptionPage />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/crop-image" element={<SignatureCropper />} />
      <Route path="/signup/success" element={<SignupSuccessPage />} />
      <Route path="/subscription" element={<SubscriptionRedirectHandler />} />
      <Route path="/docs" element={<Documentation />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/video" element={<VideoPlayer />} />

      <Route element={<Layout />}>
        {/* --- Shared Routes (Accessible by multiple roles) --- */}

        {/* All authenticated users can view their own profile, cases, and case details. */}
        <Route
          element={
            <ProtectedRoute
              allowedRoles={["field_agent", "case_manager", "admin", "client",'servers','super_admin']}
            />
          }
        >

          <Route path="/cases" element={<CaseList />} />
          <Route path="/cases/pi/:id" element={<CaseDetailsPi />} />
          <Route path="/cases/:id" element={<CaseDetail />} />
          <Route path="/users/:id" element={<UserForm />} />
          <Route path="/clients/:id" element={<ClientForm />} />
          <Route path="/teams/:id" element={<TeamForm />} />
        </Route>

        {/* Admins, Case Managers, and Field Agents can log time entries and view their dashboard. */}
        <Route
          element={
            <ProtectedRoute
              allowedRoles={["field_agent", "case_manager", "admin",'servers']}
            />
          }
        >
           <Route path="/agent/cases/pi/:id" element={<CaseDetailsPi />} />
          <Route path="/agent/tasks/edit/:taskId" element={<FieldAgentTaskUpdate />} />
           <Route path="/tasks/edit/:taskId" element={<TaskForm />} />
          <Route path="/time-entries" element={<TimeAndExpensesDashboard />} />
          <Route path="/time-entries/new" element={<TimeEntryForm />} />
          <Route path="/tasks/user/:userId" element={<MyTasks />} />
        </Route>

        {/* Admins and Case Managers can view a specific case's time entries */}
        <Route
          element={<ProtectedRoute allowedRoles={["case_manager", "admin"]} />}
        >
          <Route
            path="/time-entries/case/:caseId"
            element={<TimeEntryList />}
          />
           <Route path="/clients" element={<ClientList />} />
           <Route path="/clients/details/:id" element={<ClientDetails />} />
          <Route path="/clients/new" element={<ClientForm isNew={true} />} />
          <Route path="/invoices/new" element={<InvoiceForm />} />
          <Route path="/invoices/edit/:id" element={<InvoiceForm />} />
          <Route path="/tasks" element={<TaskList />} />
          <Route path="/tasks/new" element={<TaskForm />} />
          <Route path="/tasks/edit/:taskId" element={<TaskForm />} />
          <Route path="/cases/new" element={<CaseForm />} />
            <Route path="/cases/pi" element={<CaseListPi is_pi={true} />} />
            <Route path="/cases/pi/:id" element={<CaseDetailsPi />} />
          <Route path="/cases/pi/new" element={<CaseFormPi />} />
          <Route path="/cases/pi/edit/:id" element={<CaseFormPi />} />
          <Route path="/cases/edit/:id" element={<CaseForm />} />
          <Route path="/invoices/:id" element={<InvoiceDetail />} />
        </Route>

        {/* --- Invoice Routes (Consolidated for clarity) --- */}
        {/* All these roles can access the invoice list and detail pages */}
        <Route
          element={
            <ProtectedRoute
              allowedRoles={["case_manager", "admin", "client"]}
            />
          }
        >
          <Route path="/cases/pi/:id" element={<CaseDetailsPi />} />
          {/* Invoice list for clients is client-specific */}
          <Route path="/invoices/client/:clientId" element={<InvoiceList />} />
          {/* Invoice list for admins and managers is universal */}
          <Route path="/invoices" element={<InvoiceList />} />
          {/* Single invoice detail page for all roles */}
        </Route>

        {/* --- Role-Specific Routes --- */}

        {/* Admin-only routes */}
        <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
          <Route path="/dashboard/admin" element={<AdminDashboard />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/clients" element={<ClientList />} />
          <Route path="/teams" element={<TeamList />} />
          <Route path="/users/new" element={<UserForm isNew={true} />} />
          <Route path="/teams/new" element={<TeamForm isNew={true} />} />
          <Route path="/clients/new" element={<ClientForm isNew={true} />} />
          <Route path="/clients/export" element={<ExportClients />} />
          <Route path="/clients/import" element={<ImportClients />} />
          <Route path="/locations" element={<LocationsDashboard />} />
          <Route path="/subscriptions/manage" element={<SubscriptionManager />} />
          <Route path="/connect-stripe" element={<ConnectStripeScreen />} />
          <Route path="/dashboard/stripe/success" element={<StripeConnectSuccess />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
          <Route path="/dashboard/super_admin" element={<SuperAdminDashboard />} />
          <Route path="/organizations" element={<OrganizationsArchive />} />
          <Route path="/organizations/:id" element={<SuperAdminForm />} />
          <Route path="/organizations/view/:id" element={<OrganizationView /> } />
          <Route path="/email-templates" element={<EmailTemplates />} />
          <Route path="/audit-logs" element={<AuditLogViewer />} />
          <Route path="/users/view/:id" element={<UserDetailsPage />} />
          <Route path="/super-admin/organizations/new" element={<CreateOrganizationForm />} />
          <Route path="/super_admin/:id" element={<SuperAdminProfile />} />
          <Route path="/super-admin/users" element={<SuperAdminUserList />} />
          <Route path="/super-admin/users/:id" element={<SuperAdminUserView />} />
          <Route path="/super-admin/cases" element={<SuperAdminCaseList />} /> 
          <Route path="/super-admin/cases/:id" element={<SuperAdminCaseView />} /> 
          <Route path="/super-admin/users/:id/edit" element={<SuperAdminUserEdit />} />
          <Route path="/super-admin/transactions" element={<SuperAdminTransactions />} />
          <Route path="/super-admin/onboarding-monitor" element={<OnboardingMonitor />} />
          <Route path="/super-admin/quick-start-video" element={<QuickStartVideoManagement />} />
        </Route>

        {/* Case Manager-only routes */}
        <Route element={<ProtectedRoute allowedRoles={["case_manager"]} />}>
        <Route path="/clients" element={<ClientList />} />
        <Route path="/clients/new" element={<ClientForm isNew={true} />} />
          <Route
            path="/dashboard/case-manager"
            element={<CaseManagerDashboard />}
          />
        </Route>

        {/* Field Agent-only routes */}
        <Route element={<ProtectedRoute allowedRoles={["field_agent"]} />}>
          <Route
            path="/dashboard/field-agent"
            element={<FieldAgentDashboard />}
          />
          <Route path="/tasks/edit/:taskId" element={<TaskForm />} />
          <Route path="/agent/cases/:id" element={<MiniCaseDetail />} />
          <Route path="/agent/time-entries" element={<AgentTimeEntryList />} />
          <Route path="/agent/time-entries/new" element={<AgentTimeEntryForm />} />
          <Route path="/agent/cases" element={<AgentCasesList />} />
          <Route path="/agent/tasks/edit/:id" element={<FieldAgentTaskUpdate />} />
        </Route>


        <Route element={<ProtectedRoute allowedRoles={["servers"]} />}>
          <Route
            path="/dashboard/server"
            element={<ServerDashboard />}
          />
          <Route path="/tasks/edit/:taskId" element={<TaskForm />} />
          <Route path="/server/cases/:id" element={<CaseDetail />} />
          <Route path="/server/time-entries" element={<ServerTimeEntryList />} />
          <Route path="/server/time-entries/new" element={<ServerTimeEntryForm />} />
          <Route path="/server/cases" element={<ServerCasesList />} />
          <Route path="/server/tasks/edit/:id" element={<ServerTaskUpdate />} />
        </Route>

        {/* Client-only routes */}
        <Route element={<ProtectedRoute allowedRoles={["client"]} />}>
          <Route path="/dashboard/client" element={<ClientDashboard />} />
          <Route path="/client/cases" element={<ClientCaseList /> } />
          <Route path="client/cases/new" element={<ClientCaseForm />} />
          <Route path="client/cases/pi/new" element={<ClientCaseFormPi />} />
          <Route path="/client/cases/pi" element={<ClientCaseListPi /> } />
          <Route path="/client/cases/edit/:id" element={<ClientCaseForm />} />
          <Route path="/client/cases/pi/edit/:id" element={<ClientCaseFormPi />} />
          <Route path="/client/cases/:id" element={<CaseDetail />} />
          <Route path="/client/pi-cases/:id" element={<CaseDetailsPi />} />
          <Route
            path="/invoices/client/:clientId/:invoiceId"
            element={<PayInvoice />}
          />
        </Route>

        
      </Route>
              <Route
          path="/*" element={<Home />}
        />
    </Routes>
  );
};

export default App;
